<template>
    <div class="orderList">

        <div class="orderItem" v-for="(item , index) in dataList" :key="index">

            <div class="order_item" data-v-if="item.status === orderStatusEnum.CLOSED.id || item.status === orderStatusEnum.PAID.id">

                <!-- 只显示已支付和已关闭状态的 -->

                <div class="model_top">
                    <span class="fn fl">订单号：{{item.orderNo}}</span>
                    <span v-if="item.status === orderStatusEnum.CLOSED.id" class="fn fr" style="color:#FF474C">已取消</span>
                    <span v-if="item.status === orderStatusEnum.PAID.id" class="fn fr" style="color:#FF474C">已完成</span>
                </div>
                <div class="model_center" @click="redirectToOrderDetail(item)">
                    <div class="center_img roundBorder4" style="width:40px;height:48px;">
                        <img class="roundBorder4 fullSpace cover" src="vip/vip_order_icon.png" alt=""
                             style="width:40px;height:48px;" v-if="item.orderBizType === orderBizTypeEnum.OPEN_VIP.code">
                        <img class="roundBorder4 fullSpace cover" src="vip/vip_order_icon.png" alt=""
                             style="width:40px;height:48px;" v-else-if="item.orderBizType === orderBizTypeEnum.RENEW_VIP.code">

                        <img class="roundBorder4 fullSpace cover" :src="item.coverImg" alt=""
                             style="width:40px;height:48px;" v-else>
                    </div>
                    <div class="center_right">
                        <div class="right_title">
                            {{item.title}}
                            <span v-if="item.orderBizType === orderBizTypeEnum.DATUM.code" class="fn" style="
                                border-radius: 2px;
                                color:#FF4045;
                                border: 1px solid #FF4045;
                                padding:0px 2px;">
                                资料
                            </span>
                        </div>
                        <div class="model_top" style="margin-top:8px">
                            <span class="fn f14 color333 fl">￥{{item.price}}</span>
                            <span class="fn fr">x{{item.count}}</span>
                        </div>
                    </div>
                </div>
                <div class="model_bottom1 clearfix">
                    <span class="fl font12r" style="color: #2C2C2C; line-height: 1em" v-show="item.payInfoForm"
                        @click="viewContactInfo(item)">
                        个人信息
                        <i class="icon rightAngleBracket" style="width: 8px; height: 8px; margin-left: 2px;"></i>
                    </span>
                    <span class="fn fr color333" style="margin-right:2px;">
                            实付款￥{{item.totalPrice}}
                    </span>
                </div>
                <div class="model_bottom2 model_top">
                    <div class="fn fl">
                        {{formatDateTime(item.createTime)}}
                    </div>

                    <div class="fr flexLayout" v-if="item.status === orderStatusEnum.CLOSED.id">
                        <div @click="deleteOrder(item.orderId)" class="btn"
                             style="color:#575757;border: 1px solid #999999;margin-right:12px;">删除订单
                        </div>

                    </div>

                    <!-- 未支付 -->
                    <div class="fr flexLayout" v-if="item.status === orderStatusEnum.UNPAY.id">

                        <div v-if="item.status === orderStatusEnum.UNPAY.id">
                            <div @click="cancelOrder(item.orderId)" class="btn"
                                 style="color: #5B616C;border: 1px solid #999999;margin-right:12px;">取消订单
                            </div>
                        </div>

                        <!-- 去支付 -->
                        <div v-if="item.status === orderStatusEnum.UNPAY.id">
                            <div @click="pay(item.orderId)" class="btn orangeSolidButton">去支付
                            </div>
                        </div>
                    </div>

                    <div class="fr flexLayout" v-if="item.status === orderStatusEnum.PAID.id">

                        <div v-if="item.orderBizType === orderBizTypeEnum.DATUM.code">
                            <div class="btn" style="background: #FFA724;" @click="redirectToOrderDetail(item)">查看资料</div>
                        </div>
                        <div v-else>
                            <div class="btn" style="background: #FFA724;" @click="redirectToOrderDetail(item)">立即学习</div>
                        </div>
                    </div>

                </div>
            </div>
        </div><!-- end .orderItem -->

        <div v-show="dataList.length < 1" class="alignC white_bg paddingB20">
            <img src="icon/userIcon/no_order_icon.png" alt="" style="width: 261px; height: auto;">
        </div>

        <contactInfoDrawer ref="contactInfoDrawer" :infoList="currentContactInfoList"/>

    </div>
</template>

<script>

// part
import generalCmpPart from '@comp/part/generalCmpPart';

// component
import contactInfoDrawer from '@/components/drawer/contactInfoDrawer';

// data
import orderBizTypeEnum from '@data/orderBizTypeEnum';
import orderStatusEnum  from '@data/orderStatusEnum';

// api
import paymentManager   from '@/components/platformApi/paymentManager';
import requestManager   from "@comp/platformApi/requestManager";

// util
import {redirectToOrderDetail}  from '@/components/shixunApp/toDetail';
import appHelper            from "@/util/appHelper";
import consoleHelper        from "@/util/consoleHelper";
import objectHelper         from "@/util/objectHelper";

/*
 order data structure:
 bizId: "ef546e169b0c5c9c56f5fac66ac4f962"
 count: 1
 coverImg: null
 createTime: 1604052043000
 orderBizType: 34
 orderId: "a385067d6f7743f2b2bfcb92ef0af3d1"
 orderNo: "2010301800099176"
 price: 0.01
 status: 9
 title: "你好"
 totalPrice: 0.01
 */

const config = {
    apiConfig: {
        list: {
            url: '/portal/v4/user/center/getOrderList',
            params: {
                //    isExpire:false
            },
            dataPath: 'data.records',
            totalPath: 'data.total',
            totalPagePath: 'data.pages'
        },
        getPayStatus : {
            url : "portal/order/pay/update_order_status",
            method : 'post'
        },
    }
};

export default {
    extends : generalCmpPart,
    components : { contactInfoDrawer },
    props : {
        params : Object
    },
    data() {
        return {
            apiConfig : objectHelper.clone(config.apiConfig),
            enableDataList: true,
            scrollToLoadNextPage:false,
            pageSize: 20,

            orderBizTypeEnum : orderBizTypeEnum,
            orderStatusEnum : orderStatusEnum,

            redirectToOrderDetail : redirectToOrderDetail,
            currentContactInfoList : []
        }
    },
    methods : {
        viewContactInfo(item) {
            this.currentContactInfoList = item.payInfoForm;
            this.$refs.contactInfoDrawer.open();
        },
        deleteOrder(id) {
            requestManager.request({
                url: '/portal/v4/user/center/deleteOrder',
                method: 'delete',
                params: {
                    orderId: id
                }
            }, (error, result) => {

                let msg = result.data
                if (msg === '删除成功') {
                    appHelper.showHint('删除成功');
                    this.reloadDataList();
                }
            });
        },
        cancelOrder(id) {
            requestManager.request({
                url: '/portal/v4/order/pay/cancelOrder',
                method: 'POST',
                params: {
                    orderId: id
                }

            }, (error, result) => {

                if (result.errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }
                if (result.data) {
                    appHelper.showHint('取消成功');
                    this.reloadDataList();
                }
                else
                {
                    appHelper.showHint('取消失败');
                }
            });
        },
        pay(id) {

            const me = this;

            appHelper.showLoading();

            requestManager.request({
                url: 'portal/v4/order/pay/toPayAgain',
                method: 'POST',
                params: {
                    orderId: id,
                    payWay : paymentManager.getPaymentWay()
                }
            }, (error, result) => {

                appHelper.hideLoading();

                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                if (result.errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                const payWay = paymentManager.getPaymentWay();
                let data = result.data;
                if (typeof (data.jssdkPayConfig) === 'undefined')
                {
                    // not need pay
                    appHelper.showHint('支付成功');
                    me.reloadDataList();
                    return;
                }
                const payParams = data.jssdkPayConfig;
                const orderId = data.orderId;

                // 微信小程序环境
                wx.miniProgram.getEnv((res)=>{
                    if (res.miniprogram) {
                        wx.miniProgram.getEnv(function(res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                let pid=(payParams.package).split('=')[1];
                                let params = '?timeStamp='+payParams.timestamp
                                    +'&package='+pid
                                    +'&paySign='+payParams.paySign
                                    +'&signType='+payParams.signType
                                    +'&nonceStr='+payParams.nonceStr + '&orderId='+orderId + '&bizType=' + info.orderBizType  ;
                                let payurl='/pages/pay/pay'+params;
                                wx.miniProgram.navigateTo({url: payurl});
                                /** 跳转小程序支付，支付成功后会跳转到支付成功界面进行结算 **/
                                //监听 -> 1.搞个loading图标：结算中 ， 2.定时器轮训3一次：去请求后台有没有成功 ，如果成功了就当作是支付成功（旧逻辑） /超过10秒当作失败提示，支付失败或稍后
                                // timerManager.setInterval(()=>{
                                //     alert("监听！")
                                // },3000)
                            }
                        });
                    } else {
                        // alert("不在小程序里");
                    }
                })

                if (payWay === 'H5')
                {
                    wx.chooseWXPay({
                        timestamp: payParams.timestamp,// 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: payParams.nonceStr, // 支付签名随机串，不长于 32 位
                        package: payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                        signType: payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: payParams.paySign, // 支付签名
                        success: function (res) {// 支付成功, res 示例值 {"errMsg": "chooseWXPay:ok"}

                            me.getPayStatus(orderId, function (result) {
                                // window.location.href = './download/paySuccess.html?id=' + orderId
                                appHelper.showHint('支付成功');
                                me.reloadDataList();
                            });
                        },
                        cancel: function (res) {// 支付取消, res 示例值 {"errMsg": "chooseWXPay:cancel"}

                        },
                        fail: function (res) {// 支付失败, res 示例值 {"errMsg": "chooseWXPay:fail"}
                            appHelper.showHint("支付失败: " + res.errMsg);
                        },
                        complete: function (res) {// 不管什么状态, 最终都会调用

                        }
                    });
                }
                else
                {
                    consoleHelper.log('payWay: ' + payWay + ' unknown to do.');
                }
            });
        },
        /**
         * @method  getPayStatus
         * @param   {String}    orderId
         * @param   {Function}  callback
         */
        getPayStatus : function (orderId, callback)
        {
            const me = this;
            me.status = 'loading';

            requestManager.request({
                url: this.apiConfig.getPayStatus.url,
                method : this.apiConfig.getPayStatus.method || 'GET',
                data: {
                    orderId: orderId
                }
            }, (error, result) => {

                me.status = 'complete';

                if (callback)
                {
                    callback(result);
                }
            });
        }
    },
    mounted() {
        this.apiConfig.list.params = this.params || {};
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

.order_item {
    width: 90%;
    // height: 172px;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 12px;
    background: #fff;
    padding: 12px;
    padding-top: 8px;
    box-sizing: border-box;


}

.model_top {
    height: 17px;
    line-height: 17px;
    overflow: hidden;
}

.model_center {
    background: #F6F6F6;

    border-radius: 4px;
    margin-top: 13px;
    margin-bottom: 8px;
    box-sizing: border-box;
    padding: 8px;
    display: flex;
}

.center_img {
    width: 74px;
    height: 48px;
    border-radius: 4px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }
}

.center_right {
    flex: 1;
    margin-left: 8px;
    .right_title {

        font-size: 14px;

        font-weight: 400;
        color: #333333;

    }
}


.model_bottom1 {
    width: 100%;
    height: 17px;
    overflow: hidden;
    margin-bottom: 7px;

}

.model_bottom2 {
    width: 100%;
    height: 24px;
    line-height: 24px;
}

.btn {
    padding: 0px 7px;
    height: 24px;
    line-height: 20px;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 600;
    color: #FFFFFF;

}
.orangeSolidButton {
    width: 62px;
    height: 24px;
    line-height: 24px;
    padding: 0;
    background: #FFA724;
    border: 1px solid #FFA724;
    color: white;
    text-align: center;
}
.fn {

    font-size: 12px;


    font-weight: 400;
    // font-weight: bolder;
    color: #999999;

}
.rightAngleBracket {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAX0lEQVQ4jd3SsQ2AQAxD0Stun8ROBsgAV7IHS9AzMAU0FLQYJCTc/ydFSmtvr6o6yZABkguAneSqAsPdNzPTkcycfopExCwBADTgGt8+4buY5JDjE3j2ylXVAaQUKzsAkCs+LF/7kjcAAAAASUVORK5CYII=');
}

</style>
